import {
  Component,
  ViewEncapsulation,
  NgModule,
  ViewChild,
  ElementRef,
  Inject,
  ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DomSanitizer} from "@angular/platform-browser";
import {PDFProgressData, PdfViewerModule} from "ng2-pdf-viewer";
import {VgCoreModule} from "@videogular/ngx-videogular/core";
import {VgStreamingModule} from "@videogular/ngx-videogular/streaming";
import {Home365LoaderModule} from "../loader/home365-loader.module";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'lib-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaViewerComponent {
  @ViewChild('media') video!: ElementRef;
  loadingDoc = false;
  constructor(private cd: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) public data: { src: string, type: string, name: string, playAutomaticallyWhenReady: boolean }, public sanitizer: DomSanitizer, private dialogRef: MatDialogRef<MediaViewerComponent>) {
  }
  ngAfterViewInit() {
    this.cd.markForCheck();
  }
  close() {
    this.dialogRef.close()
  }

  onCanPlay(event: Event) {
    if (this.data?.playAutomaticallyWhenReady) {
      this.video.nativeElement.play();
    }
  }

  downloadFile(url: string) {
    const fileArray = url.split('/')
    const fileName: any = fileArray.pop();
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onProgressPdf(progressData: PDFProgressData) {
    this.loadingDoc = progressData.total != progressData.loaded
  }
}

@NgModule({
  imports: [CommonModule, VgCoreModule, VgStreamingModule, Home365LoaderModule, PdfViewerModule, MatIconModule],
  declarations: [MediaViewerComponent],
  exports: [MediaViewerComponent],
})
export class MediaViewerComponentModule {}
